import { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Await, useLoaderData } from "react-router-dom";

export default function DigitalHitlistPicker({
    formData,
    setFormData,
    name,
    filterFunction = () => true,
    disabled,
    loadOnChange,
    onChange,
    selectedId,
    onlyInput = false,
}) {
    const { digitalHitlists } = useLoaderData();

    async function handleChange(value) {
        if (onChange) {
            if (!value.length) return onChange(null);
            return onChange(value[0].digital_hitlist_id);
        }

        let formDataCopy = { ...formData, digital_hitlist: value };
        if (loadOnChange && value.length) {
            const savedFormData = await loadOnChange(value[0].digital_hitlist_id);
            if (savedFormData) {
                formDataCopy = { ...formData, ...savedFormData, digital_hitlist: value };
            }
        }
        setFormData(formDataCopy);
    }

    return (
        <Suspense fallback={<Fallback name={name} />}>
            <Await resolve={digitalHitlists}>
                {resolvedHitlists => {
                    const selectedValue = onChange ? (resolvedHitlists.data.filter(h => h.digital_hitlist_id === selectedId) ?? []) : formData?.digital_hitlist;
                    const input = (
                        <Typeahead
                            positionFixed
                            id={`${name}-digital-hitlist-selection`}
                            options={resolvedHitlists.data.filter(filterFunction)}
                            labelKey={"name"}
                            highlightOnlyResult
                            placeholder="Select digital hitlist..."
                            clearButton={true}
                            onChange={handleChange}
                            selected={selectedValue}
                            disabled={disabled || false}
                        />
                    );
                    if (onlyInput) return input;
                    return (
                        <Form.Group as={Col} className="col-12 col-xl-3 min-w-station">
                            <Form.Label>Digital Hitlist</Form.Label>
                            {input}
                        </Form.Group>
                    );
                }}
            </Await>
        </Suspense>
    );
}

function Fallback({ name }) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-3 min-w-station">
            <Form.Label>Digital Hitlist</Form.Label>
            <Typeahead id={`${name}-digital-hitlist-selection-fallback`} options={[]} placeholder="Loading digital hitlists..." disabled />
        </Form.Group>
    );
}
